
import React from 'react'

class InlineImageUploader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false
        }
    }

    handleUpload(e) {
        if (this.state.uploading) {
            return;
        }
        this.state.uploading = true;
        this.setState({});
        const files = [];
        for (let i = 0; i < e.target.files.length; i++) {
            files.push(e.target.files[i]);
        }
        const files_data = [];
        files.forEach((item, i) => {
            files_data.push({field: 'file[]', file: item});
        });
        app.api().upload('/assets/attachments/upload', files_data, {
            store: 'local', container: this.props.container, ref_type: this.props.refType, ref_id: this.props.refId,
        }, (res) => {
            if (typeof(this.props.callback) === 'function') {
                this.props.callback(res.data.items);
            }
            this.setState({uploading: false});
        }).on('error', () => {
            this.setState({uploading: false});
        });
    }

    render() {
        const uploading = this.state.uploading;
        return (
            <div className={`field`}>
                <div className="file">
                    <label className="file-label">
                        {uploading ? null : (
                            <input className="file-input" type="file" name="resume" accept={`image/*`} multiple={true} onChange={this.handleUpload.bind(this)}/>
                        )}
                        <span className="file-cta">
                            {uploading ? (
                                <span>Uploading...</span>
                            ) : (
                                <>
                                  <span className="file-icon">
                                    <i className="fas fa-upload"></i>
                                  </span>
                                  <span className="file-label">
                                    Choose a file…
                                  </span>
                                </>
                            )}
                        </span>
                    </label>
                </div>
            </div>
        )
    }
}

export default InlineImageUploader;
